export default (
  concept,
  description,
  reasons
) => `<div class="risk-description">
  <h3>${concept}</h3>
  <p>${description}</p>
  <p>${reasons ? reasons : ''}</p>
</div>`;
